{#if isVisible}
  <div
    class="ne-font-modal"
    transition:fade="{{duration: 200}}">
      <div class="ne-overlay" role="button" on:click="{toggleModal}"></div>
      <div class="ne-font-modal-contents">
        <slot></slot>
      </div>
  </div>
{/if}

<style>
  .ne-font-modal {
    box-sizing: border-box;
  }

  .ne-font-modal :global(*),
  .ne-font-modal :global(*):before,
  .ne-font-modal :global(*):after {
    box-sizing: inherit;
  }

  .ne-font-modal {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1;
  }

  .ne-font-modal-contents {
    position: relative;
    z-index: 1;
    max-width: 320px;
    margin: auto;
  }

  .ne-overlay {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 0;
  }
</style>

<script>
  import { fade } from 'svelte-transitions';

  export let isVisible;
  export let toggleModal;
</script>
